import { TResponse } from '@r1-frontend/do-request/core/types';
import { captureQueryError } from '@r1-frontend/do-request/error';

import contentRequest from '~/src/api/requests/contentRequest';

export interface IStreet {
    street_id: number,
    street_name: string,
}

interface IParams {
    providerId: number,
    term?: string,
    page?: number,
    fields?: string,
    withSatelliteFilter?: boolean,
}

export type TDataResponse = TResponse<IStreet[], any>;

/**
 * GET-запрос список улиц с фильтрацией
 *
 * /v2/street/search?fields=street_id,street_name&filter[street_name][like]=Дубр&providerId=74
 * @param {Object} params
 * @param {number} params.providerId - провайдер b2c
 * @param {string} params.term - символы содержащиеся в названии улицы
 * @param {number=} params.page - номер страницы с результатами
 * @param {string=} params.fields - возвращаемые поля
 * @param {boolean} params.withSatelliteFilter - без улиц городов-сателлитов
 * @return {{ items, _links, _meta }}
 */
export const getStreets = async(params: IParams): Promise<TDataResponse> => {
    const { providerId, term, page = 1, fields = 'street_id,street_name', withSatelliteFilter = false } = params;

    const url = '/v2/street/search';

    try {
        const response = await contentRequest.get(url, {
            params: {
                'filter[street_name][like]': term,
                ...(withSatelliteFilter ? { 'filter[smallSatelliteFilter]': true } : {}),
                page,
                fields,
                providerId,
            },
        });

        return {
            isSuccess: true,
            payload: response.data.items,
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
